import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import importModules, { defaultSliderOptions } from "./importModules";

vuwer.appendKlass("VuwSlider", {
	sliderOptions: null,
	classNames: {
		self: "vuw-slider",
		wrapper: "vuw-slide-wrapper",
		item: "vuw-slide-item"
	},
	
	/**
	 * [コンストラクタ]
	 *
	 * @param {Object} [opt]
	 * @returns this | false
	 */
	_initialize(opt) {
		if( u_.isObject(opt) ) {
			// onReadyFirstが指定されている場合は退避
			if( u_.isFunction(opt.onReadyFirst) ) {
				this._onReadyFirst = opt.onReadyFirst;
				delete opt.onReadyFirst;
			}
			
			// onReadyLastが指定されている場合は退避
			if( u_.isFunction(opt.onReadyLast) ) {
				this._onReadyLast = opt.onReadyLast;
				delete opt.onReadyLast;
			}
			
		} else {
			opt = {};
		}
		
		u_.isObject(opt.sliderOptions) || (opt.sliderOptions = {});
		opt.sliderOptions = {
			...defaultSliderOptions,
			...opt.sliderOptions
		};
		
		const _super_ = Klass("VuwSlider").parent._initialize.bind(this);
		if( !_super_(opt) ) {
			return false;
		}
		
		return this;
	},
	
	async onReadyFirst($self) {
		const VuwSlider = Klass("VuwSlider");
		await VuwSlider.importPromise;
		
		if($self) {
			$self.addClass(
				`${this.classNames.self} swiper-container`
			);
			
			const $wrapper = $self.children().eq(0);
			if($wrapper.length) {
				$wrapper.addClass(
					`${this.classNames.wrapper} swiper-wrapper`
				);
				this.setProp({ $wrapper })
				
				if(this.sliderOptions.autoplay) {
					const elm = $self.get(0);
					elm.vuw = this;
					VuwSlider.observer.observe(elm);
				}
			}
		}
		
		const args = u_.getAsArray(arguments);
		if( u_.isFunction(this._onReadyFirst) ) {
			return this._onReadyFirst(...args);
		}
	},
	
	onReadyLast($self) {
		const { $wrapper } = this;
		if($wrapper) {
			const $slides = $wrapper.children().addClass(
				`${this.classNames.item} swiper-slide`
			);
			const isSlides = ($slides.length > 1);
			this.setProp({ $slides, isSlides });
			
			if(isSlides) {
				const { Swiper } = Klass("VuwSlider");
				const { sliderOptions } = this;
				
				if(
					u_.isObject(sliderOptions.pagination) &&
					sliderOptions.pagination.el
				) {
					const { el } = sliderOptions.pagination;
					if(
						!(el instanceof HTMLElement) &&
						!u_.isString(el)
					) {
						delete sliderOptions.pagination.el;
						
					} else {
						const $elm = $(el);
						if($elm.length) {
							$elm.addClass("swiper-pagination");
							
						} else {
							delete sliderOptions.pagination;
						}
					}
				}
				
				if(
					u_.isObject(sliderOptions.navigation) &&
					(
						sliderOptions.navigation.nextEl ||
						sliderOptions.navigation.prevEl
					)
				) {
					const { nextEl, prevEl } = sliderOptions.navigation;
					if(
						(
							!(nextEl instanceof HTMLElement) &&
							!u_.isString(nextEl)
						) || (
							!(prevEl instanceof HTMLElement) &&
							!u_.isString(prevEl)
						)
					) {
						delete sliderOptions.navigation;
						
					} else {
						const $nextEl = $(nextEl);
						if($nextEl.length) {
							$nextEl.addClass("swiper-button-next");
							
						} else {
							delete sliderOptions.navigation.nextEl;
						}
						
						const $prevEl = $(prevEl);
						if($prevEl.length) {
							$prevEl.addClass("swiper-button-prev");
							
						} else {
							delete sliderOptions.navigation.prevEl;
						}
					}
				}
				
				const swiper = new Swiper($self.get(0), sliderOptions);
				swiper.init();
				
				if(sliderOptions.autoplay) {
					$wrapper.on("click", e => swiper.autoplay.stop());
				}
				
				this.setProp({ swiper });

				this.$self.addClass("slider-initialized");
			}
		}
		
		const args = u_.getAsArray(arguments);
		if( u_.isFunction(this._onReadyLast) ) {
			return this._onReadyLast(...args);
		}
	},
	
	destroySlider(deleteInstance, cleanStyles) {
		if(!this.isSlides || !this.swiper) {
			return this;
		}
		
		this.swiper.destroy(deleteInstance, cleanStyles);
		return this;
	}
});


// [IntersectionObserver as InView]
const VuwSlider = Klass("VuwSlider");
VuwSlider.observer = new IntersectionObserver(entries => {
	entries.forEach(e => {
		const { vuw } = e.target;
		if(vuw.isSlides) {
			const { autoplay } = vuw.swiper;
			!!autoplay && autoplay[e.isIntersecting ? "start" : "stop"]();
		}
	});
});

VuwSlider.importPromise = importModules().then(Swiper => {
	VuwSlider.Swiper = Swiper;
});

export default VuwSlider;
